export { MenuModule } from './menuModule';
export { MenuItemComponent } from './menu/menuItemComponent';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/menu/dist/es6/main.js
// module id = 797
// module chunks = 0